import { render, staticRenderFns } from "./FarmTable.vue?vue&type=template&id=6020d1b7&"
import script from "./FarmTable.vue?vue&type=script&lang=ts&"
export * from "./FarmTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports